import React, {useRef, useState, useMemo} from 'react'
import JoditEditor from "jodit-react";
import { FormCustom } from '../../Components/Form/Form'
import { useEffect } from 'react';
import Controllers from '../../Api/Controllers';
import { useCallback } from 'react';
import Helpers from '../../Components/Helpers/Helpers';
import { SurfaceCard, PageHeader } from '../../Components/Ui'
import {toast} from 'react-toastify'
import ReactPlaceholder from 'react-placeholder/lib';
import { useHistory } from 'react-router-dom';

const btnPrimary = {
    borderRadius: 12,
    fontWeight: 700,
    minHeight: 42,
    width: '100%',
    padding: '0 18px',
    background: '#201030',
    color: '#fff',
    border: 'none',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8
}

const StandardSeller = ({ readonly }) => {
    const [ seller, setSeller ] = useState({})
    const [ honor, setHonor ] = useState({})
    const [ready, setReady] = useState(false)

    const history = useHistory()

    const config = useMemo(() => {
        if (readonly) {
            return {
                minHeight: 450,
                preset: 'inline',
                readonly
            }
        } else {
            return {
                minHeight: 450,
                language: 'es',
                askBeforePasteHTML: false,
                askBeforePasteFromWord: false,
            }
        }
    }, [readonly])

    useEffect(() => {
        Controllers.text.get_standard_seller().then(res => {
            setSeller(res.data.seller)
            setHonor(res.data.honor)
            setReady(true)
        })
    }, [])

    const editorSeller = useRef(null)

    const contentHTMLSeller = useMemo(() => {
        return <>
        <JoditEditor
            ref={editorSeller}
            value={seller?.content_text ? seller.content_text : ''}
            config={config}
            tabIndex={1}
            onBlur={_ => {
                setSeller({ ...seller, content_text: editorSeller.current.value })
            }}
        /></>
    }, [editorSeller, seller, config])

    const editorHonor = useRef(null)

    const contentHTMLHonor = useMemo(() => {
        return <>
        <JoditEditor
            ref={editorHonor}
            value={honor?.content_text ? honor.content_text : ''}
            config={config}
            tabIndex={1}
            onBlur={_ => {
                setHonor({ ...honor, content_text: editorHonor.current.value })
            }}
        /></>
    }, [editorHonor, honor, config])

    const dataSubmit = useCallback(() => {
        return {
            p_seller: seller,
            p_honor: honor
        }
    }, [seller, honor])

    const [loadSubmit, setLoadSubmit] = useState(false)

    const handleSubmit = ({ data }) => {
        setLoadSubmit(true)
        Controllers.text.standard_seller_update(data).then(res => {
            Helpers.toast.construct({ ...res, toast, message: 'Cambios guardados correctamente.' })
            history.push(Helpers.config.convertUrl({ url: '/estandares-de-venta' }))
        }).catch(req => Helpers.promise.catch({ req, toast }))
        .finally(() => {
            setLoadSubmit(false)
        })
    }

    return <>
        <PageHeader
            eyebrow="Super Papelera — Espacio de trabajo"
            title="Estándares de Venta"
            subtitle="Edita los estándares de venta y el código de honor."
        />
        <ReactPlaceholder ready={ready} showLoadingAnimation rows={15}>
            <FormCustom dataSubmit={dataSubmit()} onSubmit={handleSubmit} loadSubmit={loadSubmit} viewSubmit={false}>
                <div className={'mb-2 col-12 col-md-' + (readonly ? '12' : '9')}>
                    <SurfaceCard>
                        <div className="form-row">
                            <div className="col-12 mb-5">
                                <h3 className="text-center" style={{ color: '#201030', fontWeight: 700 }}>Estándares de Venta</h3>
                                {contentHTMLSeller}
                            </div>
                            <div className="col-12 mb-5">
                                <h3 className="text-center" style={{ color: '#201030', fontWeight: 700 }}>Código de Honor</h3>
                                {contentHTMLHonor}
                            </div>
                        </div>
                    </SurfaceCard>
                </div>
                {readonly ? '' : <div className="col-12 col-md-3">
                    <SurfaceCard title="Actualizar">
                        <p style={{ color: '#6B7280', fontSize: '0.9rem' }}>
                            Da click en el botón para guardar los cambios realizados.
                        </p>
                        <button type="submit" style={btnPrimary}>
                            {loadSubmit
                                ? <i className="fa fa-circle-notch fa-spin" />
                                : <><i className="fa fa-plus" />Guardar Cambios</>}
                        </button>
                    </SurfaceCard>
                </div>}
            </FormCustom>
        </ReactPlaceholder>
    </>
}

StandardSeller.defaultProps = {
    readonly: false
}

export default StandardSeller
